const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

class ChatSessionService {
  getAuthToken() {
    return localStorage.getItem('token');
  }

  getHeaders() {
    const token = this.getAuthToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  }

  async getChatSessions(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });

      const response = await fetch(`${API_BASE_URL}/api/chat-sessions?${queryParams}`, {
        headers: this.getHeaders()
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al obtener las sesiones de chat');
      return data.data || data;
    } catch (error) {
      console.error('Error en getChatSessions:', error);
      throw error;
    }
  }

  async getChatSessionById(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/chat-sessions/${id}`, {
        headers: this.getHeaders()
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al obtener la sesión de chat');
      return data.data || data;
    } catch (error) {
      console.error('Error en getChatSessionById:', error);
      throw error;
    }
  }

  async deleteChatSession(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/chat-sessions/${id}`, {
        method: 'DELETE',
        headers: this.getHeaders()
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al eliminar la sesión de chat');
      return data.data || data;
    } catch (error) {
      console.error('Error en deleteChatSession:', error);
      throw error;
    }
  }
}

const chatSessionService = new ChatSessionService();
export default chatSessionService;
